import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { SpinnerLoader } from "~/components/Loaders/SpinnerLoader"
import { trpc } from "~/utils/trpc"
import { setAuthToken } from "../util"

const Layout = styled.div``

export type FeideCallbackProps = {}

const FeideCallback: React.FC<FeideCallbackProps> = () => {
  const [hasRun, setHasRun] = useState(false)

  // Get all query parameters in current url
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get("code")

  const nav = useNavigate()

  const { mutate: completeFeideLogin } =
    trpc.authentication.completeLoginFeide.useMutation({
      onSuccess(data) {
        const { token } = data

        setAuthToken(token)
        // Force a page reload to reinitialize TRPC client with new token
        window.location.href = "/"
      },
    })

  useEffect(() => {
    if (!code || hasRun) {
      return
    }

    setHasRun(true)

    completeFeideLogin({
      code: code,
    })
  }, [code, hasRun, completeFeideLogin])

  if (!code) {
    return (
      <Layout>
        <h1>FeideCallback</h1>
        <p>Error: Missing code parameter</p>
      </Layout>
    )
  }

  return (
    <Layout>
      <SpinnerLoader />
    </Layout>
  )
}

export default FeideCallback
